<template>
	<div class="SelectedFiltersContainer" :class="{ FiltersApplied: filtersApplied }">
		<div class="SelectedFiltersHeader" v-if="filtersApplied">
			Selected filters
			<button type="button" class="ClearButton" @click="clearAll" v-if="removableFiltersCount > 0">
				{{ removableFiltersCount === 1 ? 'Clear filter' : `Clear ${removableFiltersCount} filters` }}
				<i class="lnr-redo2 ButtonIcon"></i>
			</button>
		</div>
		<div class="FilterTagContainer Collapsed" ref="filterTagContainerRef">
			<div class="FilterTag" :class="{ Disabled: tag.disabled }" v-for="(tag, index) in tags" @click="tag.clear()" :key="index">
				<span class="Badge" v-if="tag.hasMultipleValues">{{ tag.count }}</span>
				<span class="FilterName">{{ tag.displayName }}</span>
				<i class="lnr-cross ButtonIcon"></i>
			</div>
		</div>
		<div>
			<button type="button" class="ShowMoreButton" ref="showMoreButtonRef" @click="showMore" v-if="shouldDisplayShowMore">
				Show more
				<i class="lnr-plus ButtonIcon"></i>
			</button>
			<button type="button" class="ShowLessButton" ref="showLessButtonRef" @click="showLess" v-if="shouldDisplayShowLess">
				Show less
				<i class="lnr-minus ButtonIcon"></i>
			</button>
		</div>
	</div>
</template>

<script lang="ts" src="./SelectedFilters.ts"></script>
<style lang="scss" src="./SelectedFilters.scss" scoped></style>
